<template>
  <main class="content">
    <!-- content -->
    <section class="add-one">
      <div class='container'>
        <div class="add-one__wrapper">
          <h1 class="add-one__title">Как это работает</h1>
          <div class="add-one__box">
            <div class="add-one__item">
              <div class="add-one__head"> <span>А</span> </div>
              <div class="add-one__text">
                Вы сами подготовите документы <br>Документы – это конструктор, который без труда «соберете» индивидуально под свою ситуацию и стоит это 299 рублей. Все ситуации типичны, а особенности Вашего дела мы тоже учли!
              </div>
            </div>
            <div class="add-one__item">
              <div class="add-one__head"><span>Б</span></div>
              <div class="add-one__text">
                Юристы потратили сотни часов чтобы тот, кому нужны юридические услуги могли все сделать сами. Остается лишь направить подготовленные жалобы, заявления, ходатайства и другие документы в зависимости от ситуации в суд или иную инстанцию.
              </div>
            </div>
            <div class="add-one__item">
              <div class="add-one__head"><span>В</span></div>
              <div class="add-one__text">
                В инструкции четко прописана вся последовательность действий и все возможные шаги – разберется даже ребенок!Берете и просто выигрываете свое дело на раз-два-три!
              </div>
            </div>
          </div>
          <div class="add-one__box-down box-one">
            <div class="box-one__video">
              <iframe src="https://www.youtube.com/embed/0picNrwktUs"></iframe>
            </div>
            <div class="box-one__text text-one">
              <h4 class="text-one__title">Проверенные решения</h4>
              <p>
                Стоит ли верить тем юристам, которые умеют хорошо продавать? А умеют ли они также хорошо решать проблемы своих клиентов?
              </p>
              <p>
                Вас могут пугать судом, рассказывать небылицы, уговаривать ни за что не ходить в суд самому, а обязательно отправить туда юриста. Об этом мы писали много раз.
              </p>
              <p>
                На самом деле, в суде важны только юридически выверенные доказательстав. Документы, которые Вы подаете в суд это и есть доказательства и работают они ровно так как они были подготовлены.
              </p>
              <p>
                Нажимайте кнопку «Получить  документы» и прямо сейчас  решите любой спор в свою пользу.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
  export default {
      name: 'how'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/how.vue